import { BreakdownAnalysisResponse } from '../models/maintenance-overview.model';

export const MOCK_IN_MAINTENANCE_DATA: BreakdownAnalysisResponse[] = [
  {
    factor: 'Total Maintenances',
    previousValue: '1 600',
    currentValue: '1 650',
    change: '+3.13%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Total Hours',
    previousValue: '3 500 hrs',
    currentValue: '3 600 hrs',
    change: '+2.86%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Total Cost',
    previousValue: 'R 16 000 000',
    currentValue: 'R 16 500 000',
    change: '+3.13%',
    impactOnEfficiency: 'Decreased on Efficiency'
  }
];

export const MOCK_OVERDUE_MAINTENANCE_DATA: BreakdownAnalysisResponse[] = [
  {
    factor: 'Overdue Tasks',
    previousValue: '120',
    currentValue: '95',
    change: '-20.83%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Overdue Assets',
    previousValue: '80',
    currentValue: '65',
    change: '-18.75%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Total Hours Overdue',
    previousValue: '320 hrs',
    currentValue: '260 hrs',
    change: '-18.75%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Overdue Maintenance Cost',
    previousValue: 'R 1 600 000',
    currentValue: 'R 1 300 000',
    change: '-18.75%',
    impactOnEfficiency: 'Increased on Efficiency'
  }
];

export const MOCK_REACTIVE_MAINTENANCE_DATA: BreakdownAnalysisResponse[] = [
  {
    factor: 'Scheduled Maintenances',
    previousValue: '1 460',
    currentValue: '1 500',
    change: '+2.74%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Approved',
    previousValue: '1 400',
    currentValue: '1 500',
    change: '+2.74%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Estimated Downtime',
    previousValue: '3 200',
    currentValue: '3 300',
    change: '+3.13%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Estimated Cost',
    previousValue: 'R 15 500 000',
    currentValue: 'R 16 000 000',
    change: '-6.67%',
    impactOnEfficiency: 'Decreased on Efficiency'
  }
];

export const MOCK_UPCOMING_MAINTENANCE_DATA: BreakdownAnalysisResponse[] = [
  {
    factor: 'Scheduled Maintenances',
    previousValue: '1 460',
    currentValue: '1 500',
    change: '+2.74%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Approved',
    previousValue: '1 400',
    currentValue: '1 500',
    change: '+2.74%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Estimated Downtime',
    previousValue: '3 200 hrs',
    currentValue: '3 300 hrs',
    change: '+3.13%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Estimated Cost',
    previousValue: 'R 15 500 000',
    currentValue: 'R 16 000 000',
    change: '-6.67%',
    impactOnEfficiency: 'Decreased on Efficiency'
  }
];